module.exports = __webpack_public_path__ + "img/DNARepair-INCA_10X_IC.a7969194.png";